import axios from 'axios';
import { DOMAIN_URL } from '../../constants/url'; 

const axiosInstanceReportErrorFile = axios.create({
  baseURL: DOMAIN_URL,  
  headers: {
    'Content-Type': 'multipart/form-data', 
  },
  responseType: "json",  
});

axiosInstanceReportErrorFile.interceptors.request.use(
  (config) => { 
    const token = localStorage.getItem('accessToken');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`; 
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);


export default axiosInstanceReportErrorFile;
